import { serviceInstance as api } from "../service";
import { serviceUploadInstance as apiUpload } from "../service.upload";

import { FileGetDTO } from "./dto";

export const getFiles = async () => {
  const response = await api().get("/pedido/errorfile");
  return response.data?.result?.data.map(file => new FileGetDTO(file))
};


export const sendFiles = async (data) => {
  let formData = new FormData();
  formData.append("file",data);
  
  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));
  const { username } = getEmail;

  const response = await apiUpload().post(`/evento/telemercadeo/file?usuario=${username}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response;
};

